import { css } from 'styled-components';
import { fontStyle } from '../typography';
export const SSITextH1Css = css `
  font-family: ${fontStyle.h1Regular.fontFamily};
  font-size: ${fontStyle.h1Regular.fontSize}px;
  font-weight: ${fontStyle.h1Regular.fontWeight};
  line-height: ${fontStyle.h1Regular.lineHeight}px;
  height: auto;
`;
export const SSITextH2Css = css `
  font-family: ${fontStyle.h2Regular.fontFamily};
  font-size: ${fontStyle.h2Regular.fontSize}px;
  font-weight: ${fontStyle.h2Regular.fontWeight};
  line-height: ${fontStyle.h2Regular.lineHeight}px;
  height: auto;
`;
export const SSITextH3Css = css `
  font-family: ${fontStyle.h3Regular.fontFamily};
  font-size: ${fontStyle.h3Regular.fontSize}px;
  font-weight: ${fontStyle.h3Regular.fontWeight};
  line-height: ${fontStyle.h3Regular.lineHeight}px;
  height: auto;
`;
export const SSITextH4Css = css `
  font-family: ${fontStyle.h4Regular.fontFamily};
  font-size: ${fontStyle.h4Regular.fontSize}px;
  font-weight: ${fontStyle.h4Regular.fontWeight};
  line-height: ${fontStyle.h4Regular.lineHeight}px;
  height: auto;
`;
export const SSITextH4SemiBoldCss = css `
  font-family: ${fontStyle.h4SemiBold.fontFamily};
  font-size: ${fontStyle.h4SemiBold.fontSize}px;
  font-weight: ${fontStyle.h4SemiBold.fontWeight};
  line-height: ${fontStyle.h4SemiBold.lineHeight}px;
  height: auto;
`;
export const SSITextH5Css = css `
  font-family: ${fontStyle.h5Regular.fontFamily};
  font-size: ${fontStyle.h5Regular.fontSize}px;
  font-weight: ${fontStyle.h5Regular.fontWeight};
  line-height: ${fontStyle.h5Regular.lineHeight}px;
  height: auto;
`;
export const SSITextH6Css = css `
  font-family: ${fontStyle.h6.fontFamily};
  font-size: ${fontStyle.h6.fontSize}px;
  font-weight: ${fontStyle.h6.fontWeight};
  line-height: ${fontStyle.h6.lineHeight}px;
  height: auto;
`;
